import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    class: "container-fluid p-0 m-0 h-100 w-100 position-relative",
    ref: "__container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_resize2 = _resolveDirective("resize2");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            style: _normalizeStyle('position: absolute;display: block; width: ' + _ctx._width + '; height: ' + _ctx._height)
        }, [
            _renderSlot(_ctx.$slots, "default")
        ], 4)
    ])), [
        [_directive_resize2, _ctx.onResize]
    ]);
}
